<template>
  <div>
    <!-- <router-view v-if="selectedRouteName=='login'" name="login"></router-view>
    <router-view v-if="selectedRouteName=='preview'" name="preview"></router-view> -->
    <router-view :name="selectedRouteName" :ref="'home_'+selectedRouteName"></router-view>
    <div id="external-plugins-wrapper" ref="externalPluginWrapperRef" style="display:none;">

    </div>
  </div>
</template>

<script>
import Utils from "./components.utils.js"
import {mapActions, mapMutations, mapGetters} from "vuex"

import axios from 'axios';
import iframePluginsMixin from './mixins/iframePluginsMixin.js';
import '@/assets/styles/rtl.scss';

export default {
  name:"App",
//   name: "App",
//   metaInfo: {
//     title: Utils.getDefaultTitle()
//   },
  mixins:[iframePluginsMixin],
  methods:{
    ...mapActions("users", [ "loadUserInfoFromCookies","getUserInfoFromServer"]),
    ...mapActions("language", ["fetchUserPrefferedLanguage"]),
    ...mapMutations("locations", ["setLoadPageInfo","setPathLocationInfo"]),
    ...mapGetters("locations",["getLocationinfoToLoad"]),
    ...mapGetters("users", ["getLoggedInUser"]),
    ...mapGetters("pluginRepo",["getInstalledPluginsData"]),
    loadExternalOnDemandPlugin(routeInfo){
      let installedPlugins = [], pluginInfo = null;
      const pluginMap = {
          review:{
              name:[
                "asset-new-review","new-review"
              ],
              value:'Review' ,
              callback:'externalpluginDialogUiCallback',
              isLoadRequired:true,
              pushType:'replace', // if you don't want forward backward support then replace otherwise push or leave it blank
              props:{
                 key:'fileInfo',
                 fileInfo: function (vm){ // this function will execute at run time
                    console.log('vmmmmmmmmm',vm);
                    return JSON.parse(JSON.stringify(vm.selectedFileDetails.singlefile)); 
                 }
              }
           },
           mediashare:{
              name:[
                "asset-share-with-user","share-with-user","asset-share-with-user-from-global-btn","share-with-user-from-global-btn",
                "metadata-manager-asset-share-with-user"
              ],
              value:'Share' ,
              callback:'externalpluginDialogUiCallback',
              isLoadRequired:true,
              pushType:'replace', // if you don't want forward backward support then replace otherwise push or leave it blank
              props:{
                 key:'filesInfo',
                 filesInfo: function (vm){ // this function will execute at run time
                    return JSON.parse(JSON.stringify(vm.selectedFileDetails)); 
                 }
              }
           },
           /*
           OBD:{
              name:[
                "asset-object-detection","file-object-detection"
              ],
              value:'OBD' ,
              callback:'externalpluginDialogUiCallback',
              isLoadRequired:true,
              pushType:'replace', // if you don't want forward backward support then replace otherwise push or leave it blank
              props:{
                 key:'filesInfo',
                 filesInfo: function (vm){ // this function will execute at run time
                    return JSON.parse(JSON.stringify(vm.selectedFileDetails)); 
                 }
              }
           },
           */
           /*Email:{
              name:[
                "asset-share-via-email","share-via-email"
              ],
              value:'Share' ,
              callback:'externalpluginDialogUiCallback',
              isLoadRequired:true,
              props:{
                 key:'filesInfo',
                 filesInfo: function (vm){ // this function will execute at run time
                    return JSON.parse(JSON.stringify(vm.selectedFileDetails)); 
                 }
              }
           },*/
      };
      if(typeof this.getInstalledPluginsData == "function"){
        installedPlugins = this.getInstalledPluginsData();
      }else{
        installedPlugins = this.getInstalledPluginsData;
      }

      let callback = '', isLoadRequired = false, props = {}, pushType = 'push';
      for(let key in pluginMap){
          if(key && pluginMap[key]){
             if(pluginMap[key].name.indexOf(routeInfo.name) > -1){
                pluginInfo = installedPlugins.find(e => String(e.plugin_name).toLowerCase() == String(key).toLowerCase());
                if(pluginMap[key] && pluginMap[key].callback)  callback = pluginMap[key].callback;
                if(pluginMap[key] && Object.prototype.hasOwnProperty.call(pluginMap[key],'isLoadRequired')) 
                       isLoadRequired = pluginMap[key].isLoadRequired;
                if(pluginMap[key] && Object.prototype.hasOwnProperty.call(pluginMap[key],'props'))
                    props = pluginMap[key].props;
                 if(pluginMap[key] && Object.prototype.hasOwnProperty.call(pluginMap[key],'pushType'))
                    pushType = pluginMap[key].pushType;
                break;
             }
          }
      }

      if(this.$refs['home_explorer'] && pluginInfo){
        this.$refs['home_explorer'].loadExternalWorkspacePlugin(pluginInfo,routeInfo.name,{},true,callback,{route:routeInfo,isLoadRequired:isLoadRequired,pushType:pushType,id:new Date().valueOf(),props:{...props}});
        return true;
      }
      return false;
    },

    getUserInfo(){
       return new Promise((resolve)=>{
          if(localStorage.getItem('fusion:u_id') != null){
            this.getUserInfoFromServer({params:{userId:JSON.parse(localStorage.getItem('fusion:u_id'))}}).then((data) => {
                  if(data && Object.keys(data).length && Utils.isAcceptedStatusCode(data.statusCode)){
                     resolve();
                  }else{
                    this.$router.push({name:'login',query:{
                      continue: '/fusion-browse/blaze/files',
                    }})
                  }
             });
          }else{ //for the first time
             this.$cookies.remove("session_id");
             localStorage.removeItem('sessionId');
             this.$router.push({name:'login',query:{
               continue: '/fusion-browse/blaze/files',
             }})
          }
       });
    },
    getUserInfoForNRAA(){
      return new Promise((resolve)=>{
          if(localStorage.getItem('fusion:u_id') != null){
              this.getUserInfoFromServer({params:{userId:JSON.parse(localStorage.getItem('fusion:u_id'))}}).then((data) => {
                 if(data && Object.keys(data).length && Utils.isAcceptedStatusCode(data.statusCode)){
                     resolve();
                  }else{
                    this.$router.push({name:'login',query:{
                      continue: '/fusion-browse/NRAA/uploadMetadata',
                    }})
                  }
             });
          }else{  // for the first time
             this.$cookies.remove("session_id");
             localStorage.removeItem('sessionId');
             this.$router.push({name:'login',query:{
               continue: '/fusion-browse/NRAA/uploadMetadata',
             }})
          }
       });
    },

  },
  data(){
    return {
       selectedRouteName:'explorer',
      //  languageMapper:{},
      //  languageOrientation : 'LTR',
      //  rtlLanguages : ['ar', 'he', 'fa', 'ur'],
    }
  },
  watch:{
    $route: {
            immediate: true,
            handler(to) {
                document.querySelector('head meta[property=og\\:url]').setAttribute('content',window.location.href);
                document.querySelector('head meta[property=og\\:title]').setAttribute('content',to.meta.title);
                if('description' in to.meta){
                  document.querySelector('head meta[property=og\\:description]').setAttribute('content',to.meta.description);
                }

                if(to && to.name == 'login' && this.getLoggedInUser() == null){
                    this.selectedRouteName = 'login';
                    //this.determinePreviewURL();
                }else if(to && to.name == 'explorer'){
                    this.selectedRouteName = 'explorer';
                }else if(to && to.name == 'preview'){
                   this.selectedRouteName = 'preview';
                }else if(to && to.name == 'terms'|| to.name == 'policy'){
                   this.selectedRouteName = to.name;
                }
            }
    },
    '$i18n.locale'() {
      this.applyDirection();
      this.updateToastDirection();
    },
  },
/*   computed:{
    selectedRouteName(){
      if (this.isDamPreview){
        return "explorer"
      }else{
        return "login"
      }
    }
  }, */
  created(){
    if((window.self !== window.top) && (window.name || window.name && window.name !='browse' || window.name && window.name !='fusion-browse')){
        console.log("inside iframe");
        console.log("Plugin name ...............",window.name);
        this.loadPluginsWithinIframe();
        return;
    }
    // eslint-disable-next-line no-undef
    this.loadUserInfoFromCookies()
    let loadFusionExplorer = true; 

    if(this.$route.query &&
     ["/fusion-browse/blaze/files", "/fusion-browse/NRAA/uploadMetadata"].includes(this.$route.query.continue)){
      loadFusionExplorer = false
     }

    if(String(this.$route.name).indexOf('blaze_fusion_') > -1 || String(window.location.href).indexOf('fusion-browse/blaze') > -1){
      this.getUserInfo().then(()=>{
        this.selectedRouteName = 'blaze_fusion_browse';
        let p = {name:'blaze_fusion_browse'};
        if(Object.keys(this.$route.query).length){
            Object.assign(p,{query: this.$route.query});
        }
        this.$router.replace(p); //replace will not hold in history
      });
      return;
    }

    if(String(this.$route.name).indexOf('NRAA_upload_metadata') > -1 || String(window.location.href).indexOf('fusion-browse/NRAA') > -1){
      this.getUserInfoForNRAA().then(()=>{
        this.selectedRouteName = 'NRAA_upload_metadata';
        let p = {name:'NRAA_upload_metadata'};
        if(Object.keys(this.$route.query).length){
            Object.assign(p,{query: this.$route.query});
        }
        this.$router.replace(p); //replace will not hold in history
      });
      return;
    }

    if (this.$route.name != "login" && this.$route.name != "preview" &&
     String(this.$route.name).indexOf('blaze_fusion_') == -1 &&
      String(this.$route.name).indexOf('NRAA_upload_metadata') == -1 && loadFusionExplorer){
      //this.setLoadPageInfo(this.$route);
       this.setLoadPageInfo(this.$route);
       if(this.$route && (this.$route.name)){
         this.setLoadPageInfo(this.$route);
       }else{
         let url = new URL(window.location.href);
         let p = url.pathname + url.search;
         this.setPathLocationInfo(p);
      }
      this.$router.push({name:'explorer'}); //un-commented because chat , review and other external plugins were not loading.
    }

    if(this.$route.name == 'preview'){
        this.selectedRouteName = 'preview';
        this.$router.push({name:'preview'});
    }
  },
  beforeCreate(){
    axios.interceptors.request.use((config) => {
        try{
            if(String(window.location.href).includes('fusion-browse/blaze/files') && String(config.url).indexOf('/login') == -1){
                 config.headers['session-id'] = localStorage.getItem('sessionId');
                 if(String(config.url).indexOf('/logout') > -1){
                    this.$router.push({name:'login',query:{
                      continue: '/fusion-browse/blaze/files',
                    }})
                 }
            }
        }catch(e){console.log(e)}
          
        try{
          if(window.self !== window.top) {
              console.log("Opened inside iframe......");
              config.headers['session-id'] = localStorage.getItem('sessionId');
          }
        }catch(e){console.log(e)}
        

        return config;
    });
  },
  mounted(){
    this.initializeLanguage();

    
    // var script = document.createElement('script');
    // script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js';
    // script.type = 'text/javascript';
    // document.getElementsByTagName('head')[0].appendChild(script);  
    //  this.determinePreviewURL();
  },
};
</script>

<style lang="scss">
  $border-color: 1px solid #4a4a4a;
  $border-color-only:#4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $danger-color: #dc3545 !important;
  $input-field-height:38px;
  $none-text-color:#4f4f4f;
  $input-field-padding:.375rem 10px;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;
  $tags-background-color:#282d31;
  $tags-border-color:#363636;
  $metadata-border-color-on-hover: #5a5a5a;
  $secondary-border-color: 1px solid #2b2b2b;
  $active-green-color:#28a745;
  $svg-color:#666;
  $learn-about-text-color-hover:#b7b327;
  $active-green-icon-color: #00ff3a;
  $learn-about-text-color:#9a9620;
  $icon-hover:#2c3339;

#app {
  font-family: "Roboto", Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center !important;
  color: $text-color !important;
  letter-spacing: normal;
  margin-top: 60px;
  background: $primary-background !important;
  height: 100vh;
  font-size: 14px !important;
  margin-block-start: 0em !important;
  margin-block-end: 0em !important;
  cursor: pointer;
  overflow: hidden;
  user-select: none; 
}

@font-face {
  font-family: "Roboto";
  src: local("Roboto"), url(./fonts/Roboto/Roboto-Medium.ttf) format("truetype");
}

@font-face {
  font-family: "Alkatra";
  src: local("Alkatra"), url(./fonts/alkatra/Alkatra-VariableFont_wght.ttf) format("truetype");
}
@font-face {
  font-family: "EduNSWACT";
  src: local("EduNSWACT"), url(./fonts/EduNSWACT/EduNSWACTFoundation-VariableFont_wght.ttf) format("truetype");
}
@font-face {
  font-family: "Fasthand";
  src: local("Fasthand"), url(./fonts/Fasthand/Fasthand-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "Quicksand";
  src: local("Quicksand"), url(./fonts/QuickSand/Quicksand-VariableFont_wght.ttf) format("truetype");
}
@font-face {
  font-family: "Dosis";
  src: local("Dosis"), url(./fonts/Dosis/Dosis-VariableFont_wght.ttf) format("truetype");
}
@font-face {
  font-family: "Tillana";
  src: local("Tillana"), url(./fonts/Tillana/Tillana-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "Lobster";
  src: local("Lobster"), url(./fonts/Lobster/Lobster-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "Satisfy";
  src: local("Satisfy"), url(./fonts/Satisfy/Satisfy-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "RedhatDisplay";
  src: local("RedhatDisplay"), url(./fonts/RedhatDisplay/RedHatDisplay-VariableFont_wght.ttf) format("truetype");
}




body {
  background: $primary-background !important;
  font-family: "Roboto", Arial, sans-serif !important;
  color: $text-color;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center !important;
  color: $text-color !important;
  letter-spacing: normal;
  margin-top: 60px;
  background: $primary-background !important;
  height: 100%;
  font-size:14px !important;
  margin-block-start: 0em !important;
  margin-block-end: 0em !important;
  cursor: pointer;
  overflow:hidden;
  user-select: none; 
}

.table>:not(caption)>*>* {
    border-bottom-width: 0 !important;
    padding:0.75rem !important;
}

html{
  overflow: auto;
}

.border{
  border:$border-color !important;
}
    
select{
  -webkit-appearance: menulist;
  option {
    margin: 40px;
    background: $secondary-background-color;
    color: #fff;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  }
} 

/* width */
  ::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $secondary-background-color;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $primary-background;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover;
  }


.dropdown-toggle:after{
  display:none !important;
}

.modal{
  overflow: hidden !important;
}

.dropdown-menu{
  background-color:$secondary-background-color !important;
  border: $border-color;
  .dropdown-item{
    color:$text-color;
    font-size:14px !important; 
  }
  .dropdown-item:hover{
    background: $bg-color-on-hover !important;
  }
}

// :focus-visible {
//     outline: unset;
// }

input:focus,select:focus{
    outline: none;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}
::placeholder{
  font-size: 14px!important;
  font-family: Roboto,Arial,sans-serif!important;
  color: #adadad !important;
  display: inline-block;
  margin-bottom: 10px;
  padding-top: 2px;
}

 #import_handler_drag_ghost {
    width: 65px;
    background-color: rgb(0, 217, 255);
    text-align: center;
    color: #fff;
    padding: 4px;
  }
  
@import '~suneditor/dist/css/suneditor.min.css';
</style>


